import HeaderBack from "@/components/fragments/HeaderBack";
import ActivityDetailFeature from "@/features/ActivityDetail";
import { useParams } from "react-router-dom";

export default function ActivityDetailPage() {
  const { id } = useParams();
  return (
    <main className="md:w-[80vw] px-2 lg:w-[70vw] mx-auto ">
      <HeaderBack text="Detail Transaksi" url="/activity" />

      <ActivityDetailFeature id={id} />
    </main>
  );
}
